document.addEventListener('DOMContentLoaded', function() {
  var dataEl = document.getElementById('pp-variants-data');
  if (!dataEl) return;

  var variants;
  try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
  if (!variants || !variants.length) return;

  var variantInput = document.getElementById('pp-variant');
  var cartQtyInput = document.getElementById('pp-cart-qty');
  var totalEl = document.getElementById('pp-total');
  var wasEl = document.getElementById('pp-was');
  var wasWrap = document.getElementById('pp-was-wrap');
  var kgLabel = document.getElementById('pp-kg-label');
  var formatsWrap = document.getElementById('pp-formats');
  var form = document.getElementById('pp-form');
  var stockBadge = document.getElementById('pp-stock-badge');
  var qtyMinus = document.getElementById('pp-qty-minus');
  var qtyPlus = document.getElementById('pp-qty-plus');
  var perKgSuffix = window.__ppCfg.perKg;
  var strSavePerKg = window.__ppCfg.savePerKg;

  var strInStock = window.__ppCfg.inStock;
  var strBackordered = window.__ppCfg.backordered;
  var strPartialOk = window.__ppCfg.partialOk;
  var strPartialBo = window.__ppCfg.partialBo;

  // Format initial = celui choisi par le SSR (input cache : ?variant= ou plus petit
  // format affiche). Le bouton actif SSR porte la meme variante.
  var selected = 0;
  if (variantInput) {
    for (var si = 0; si < variants.length; si++) {
      if (String(variants[si].id) === String(variantInput.value)) { selected = si; break; }
    }
  }

  var __locale = window.__ppCfg.locale;
  var __fmtLocale = (__locale === 'fr') ? 'fr-CA' : 'en-CA';
  function fmt(cents) {
    return new Intl.NumberFormat(__fmtLocale, {style: 'currency', currency: 'CAD'}).format(cents / 100);
  }

  // Sous-titre d'un bouton de format. Deux chemins l'ecrivent (upgrade SSR et
  // rebuild fallback) : les garder synchrones a la main a deja produit un bug.
  // fmt() = Intl.NumberFormat, aucune donnee arbitraire n'entre dans ce HTML.
  function subHtml(v) {
    /* weight_g = 0 (kits, poids non parsable) -> pas de prix/kg affichable */
    var was = (v.compare_at && v.compare_at > v.price)
      ? '<s class="pp-fmt__was">' + fmt(v.compare_at) + '</s>'
      : '';
    if (!v.weight_g || v.weight_g <= 0) return was + fmt(v.price);
    var perkgCents = Math.round(v.price * 1000 / v.weight_g);
    return was + fmt(v.price) + ' <span class="pp-fmt__perkg">(' + fmt(perkgCents) + perKgSuffix + ')</span>';
  }

  function weightKg(wg) {
    return wg / 1000;
  }

  function getQty() {
    if (!cartQtyInput) return 1;
    var val = parseInt(cartQtyInput.value, 10);
    return (isNaN(val) || val < 1) ? 1 : val;
  }

  function setQty(n) {
    if (!cartQtyInput) return;
    n = Math.max(1, Math.floor(n));
    cartQtyInput.value = n;
    update();
  }

  // Stepper buttons
  if (qtyMinus) qtyMinus.addEventListener('click', function() { setQty(getQty() - 1); });
  if (qtyPlus) qtyPlus.addEventListener('click', function() { setQty(getQty() + 1); });
  if (cartQtyInput) {
    cartQtyInput.addEventListener('input', function() { update(); });
    cartQtyInput.addEventListener('change', function() {
      var val = parseInt(cartQtyInput.value, 10);
      if (isNaN(val) || val < 1) cartQtyInput.value = 1;
      else cartQtyInput.value = Math.floor(val);
      update();
    });
  }

  // Find 1 kg reference price/kg for save badges
  var ref1kg = null;
  variants.forEach(function(v) {
    if (v.weight_g === 1000) ref1kg = v.price / weightKg(v.weight_g);
  });

  function buildSaveBadge(btn, v) {
    try {
      if (ref1kg && v.weight_g > 1000) {
        var perkgThis = v.price / weightKg(v.weight_g);
        var savePct = Math.round((ref1kg - perkgThis) / ref1kg * 100);
        if (savePct > 0) {
          var saveSpan = document.createElement('span');
          saveSpan.className = 'pp-fmt__save';
          saveSpan.textContent = strSavePerKg.replace('__pct__', savePct);
          btn.appendChild(saveSpan);
        }
      }
    } catch (e) { /* badge is cosmetic — never block the buy box */ }
  }

  // Upgrade SSR format buttons: bind click listeners & update prices with JS-formatted values
  var existingBtns = formatsWrap.querySelectorAll('.pp-fmt');
  if (existingBtns.length === variants.length) {
    // SSR buttons match variant count — upgrade in place
    existingBtns.forEach(function(btn, i) {
      var v = variants[i];
      var subSpan = btn.querySelector('.pp-fmt__sub');
      if (subSpan) {
        subSpan.innerHTML = subHtml(v);
      }
      var existingSave = btn.querySelector('.pp-fmt__save');
      if (!existingSave) buildSaveBadge(btn, v);
      btn.addEventListener('click', function() {
        formatsWrap.querySelectorAll('.pp-fmt').forEach(function(b) {
          b.classList.remove('pp-fmt--active');
          b.setAttribute('aria-pressed', 'false');
        });
        btn.classList.add('pp-fmt--active');
        btn.setAttribute('aria-pressed', 'true');
        selected = i;
        update();
      });
    });
  } else if (formatsWrap.querySelector('.pp-fmt[disabled]')) {
    // B2B-locked SSR buttons (disabled) — never rebuild, keep server-side gating intact
  } else {
    // Fallback: clear and rebuild (SSR count mismatch)
    formatsWrap.innerHTML = '';
    variants.forEach(function(v, i) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'pp-fmt' + (i === selected ? ' pp-fmt--active' : '');
      btn.setAttribute('data-idx', i);
      btn.setAttribute('aria-pressed', i === selected ? 'true' : 'false');
      var nameSpan = document.createElement('span');
      nameSpan.className = 'pp-fmt__name';
      nameSpan.textContent = v.label;
      var subSpan = document.createElement('span');
      subSpan.className = 'pp-fmt__sub';
      subSpan.innerHTML = subHtml(v);
      btn.appendChild(nameSpan);
      btn.appendChild(subSpan);
      buildSaveBadge(btn, v);
      btn.addEventListener('click', function() {
        formatsWrap.querySelectorAll('.pp-fmt').forEach(function(b) {
          b.classList.remove('pp-fmt--active');
          b.setAttribute('aria-pressed', 'false');
        });
        btn.classList.add('pp-fmt--active');
        btn.setAttribute('aria-pressed', 'true');
        selected = i;
        update();
      });
      formatsWrap.appendChild(btn);
    });
  }

  function updateBadge() {
    if (!stockBadge) return;
    var v = variants[selected];
    var qty = getQty();
    var kg = weightKg(v.weight_g);

    if (v.inv_qty === null) {
      // Not tracked = always in stock
      stockBadge.className = 'pp-stock-badge pp-stock-badge--ok';
      stockBadge.innerHTML = '<div class="pp-stock-badge__line">\u2713 ' + strInStock + '</div>';
      return;
    }

    var stock = Math.max(v.inv_qty, 0);

    if (stock === 0) {
      // Full backorder
      stockBadge.className = 'pp-stock-badge pp-stock-badge--warn';
      stockBadge.innerHTML = '<div class="pp-stock-badge__line">' + strBackordered + '</div>';
    } else if (qty <= stock) {
      // All in stock
      stockBadge.className = 'pp-stock-badge pp-stock-badge--ok';
      stockBadge.innerHTML = '<div class="pp-stock-badge__line">\u2713 ' + strInStock + '</div>';
    } else {
      // Partial
      var okKg = (stock * kg).toFixed(1).replace(/\.0$/, '');
      var boKg = ((qty - stock) * kg).toFixed(1).replace(/\.0$/, '');
      var lineOk = strPartialOk.replace('__x__', okKg);
      var lineBo = strPartialBo.replace('__y__', boKg);
      stockBadge.className = 'pp-stock-badge pp-stock-badge--partial';
      stockBadge.innerHTML = '<div class="pp-stock-badge__line pp-stock-badge__line--ok">\u2713 ' + lineOk + '</div>' +
        '<div class="pp-stock-badge__line pp-stock-badge__line--warn">\u26A0 ' + lineBo + '</div>';
    }
  }

  function update() {
    var v = variants[selected];
    var kg = weightKg(v.weight_g);
    var pricePerKg = kg > 0 ? v.price / kg : 0;

    // Prix de la ligne = prix unitaire x quantite. Le prix/kg reste un taux unitaire.
    if (totalEl) totalEl.textContent = fmt(v.price * getQty());
    // Prix barre = compare_at x quantite, pour rester comparable au total affiche.
    // 0 (variantes B2B, compare_at_price null) => on masque le bloc entier plutot
    // que d'afficher un <s> vide.
    if (wasWrap) {
      var cmp = v.compare_at || 0;
      if (cmp > v.price) {
        if (wasEl) wasEl.textContent = fmt(cmp * getQty());
        wasWrap.hidden = false;
      } else {
        wasWrap.hidden = true;
      }
    }
    if (kgLabel) kgLabel.textContent = pricePerKg > 0 ? fmt(pricePerKg) + perKgSuffix : '';
    if (variantInput) variantInput.value = v.id;

    updateBadge();
  }

  update();

  // AJAX add to cart
  if (form) {
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      var btn = document.getElementById('pp-submit');
      if (!btn || btn.disabled) return;
      var errEl = document.getElementById('pp-error');
      if (errEl) errEl.style.display = 'none';
      var origText = btn.innerHTML;
      btn.textContent = '\u2026';
      var cartDrawer = document.querySelector('cart-drawer');
      var sectionsToFetch = cartDrawer
        ? cartDrawer.getSectionsToRender().map(function(s) { return s.id; })
        : [];

      var payload = {
        id: parseInt(variantInput.value),
        quantity: getQty()
      };
      if (sectionsToFetch.length) {
        payload.sections = sectionsToFetch;
        payload.sections_url = window.location.pathname;
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      }).then(function(response) {
        if (!response.ok) {
          return response.json().catch(function() { return {}; }).then(function(d) {
            throw new Error(d.description || 'Error adding to cart. Please try again.');
          });
        }
        return response.json();
      }).then(function(data) {
        btn.innerHTML = origText;
        if (cartDrawer && data.sections) {
          cartDrawer.renderContents(data);
        } else if (window.LSHeader && typeof window.LSHeader.refreshCart === 'function') {
          /* Le mini-panier est <aside class="cart-drawer"> pilote par assets/header.js,
             plus un <cart-drawer> : sans ce chemin, chaque ajout rechargeait /cart. */
          var openDrawer = function() {
            if (typeof window.LSHeader.openCart === 'function') window.LSHeader.openCart();
          };
          var p = window.LSHeader.refreshCart();
          if (p && typeof p.then === 'function') { p.then(openDrawer); } else { openDrawer(); }
        } else {
          window.location.href = window.__ppCfg.cartUrl;
        }
      }).catch(function(err) {
        btn.innerHTML = origText;
        if (errEl) { errEl.textContent = err.message; errEl.style.display = 'block'; }
      });
    });
  }
});
